import { Component } from "@angular/core";
import { CoreDotLoader } from "@svs/angular";

@Component({
  selector: "app-chat-answer-loading",
  imports: [
    CoreDotLoader,
  ],
  templateUrl: "./chat-answer-loading.component.html",
  styleUrl: "./chat-answer-loading.component.scss",
})
export class ChatAnswerLoadingComponent {

}
